import { useEffect } from 'react';
import { hookstate, useHookstate } from '@hookstate/core';
import { getConfig, getEspotData, getItemsBySKU, useConfig, useEspotData } from '~/store/Query/api';

export const planesState = hookstate([]);

const planesNameState = hookstate({});

export const usePlanesState = (enabled) => {
  const planes = (planesState);
  useEffect(() => {
    async function init() {
      if (enabled && planes.value?.length) {
        const sku = planes.value.filter(plan => !planesNameState.value[plan]);
        if (sku.length) {
          const res = await getItemsBySKU({ sku });
          if (res.ok) {
            planesNameState.merge(res.body.reduce((obj, prod) => {
              obj[prod.items[0].part_number] = prod.items[0].locales[process.env.NEXT_PUBLIC_LOCALE].name;
              return obj;
            }, {}));
          }
        }
      }
    }

    init();
  }, [planes.value]);
  return useHookstate(planesNameState);
};

export const CONEQUIPO = 'CONEQUIPO';
export const SINEQUIPO = 'SINEQUIPO';
export const AMBOS = 'AMBOS';
export const PAGOUNICO = 'PAGOUNICO';

export const planesEquipo = hookstate({
  config: {
    product_sku_sin_equipo: 'K01_0001_001',
    mostrar_plazos_sin_equipo: '1',
    titulo_categoria_con_equipo: 'Planes todo incluido',
    descripcion_categoria_con_equipo: 'Adquiere tu plan postpago con contrato el cual incluye smartphone 5G, llamadas ilimitadas, redes sociales ilimitadas, música ilimitada y paquete de navegación incluido',
    tipo_postpago_predefinido: CONEQUIPO,
    terminos_condiciones_sin_equipo: '',
    titulo_categoria_sin_equipo: 'Planes sin equipo',
    descripcion_categoria_sin_equipo: 'Adquiere un plan postpago sin contrato para tu smartphone el cual incluye llamadas ilimitadas, redes sociales ilimitadas, música ilimitada y paquete de navegación incluido',
  },
  tipo: null,
  show: false,
  changeTipo: 0,
});

const setPopagoState = (data) => {
  planesEquipo.config.merge(data);
  planesEquipo.config.product_sku_sin_equipo.set(planesEquipo.config.product_sku_sin_equipo.value.replace(/[.]/g, '_'));
  if (!planesEquipo.tipo.value) {
    planesEquipo.tipo.set(planesEquipo.config.tipo_postpago_predefinido.value);
  }
};

export const usePospagoState = (enabled = true) => {
  const config = useConfig('configuracion_tienda', enabled);
  useEffect(() => {
    if (config.data?.ok) {
      const info = config.data.body.data;
      setPopagoState(info.texto);
    }
  }, [config.data]);
  return useHookstate(planesEquipo);
};

export const getPospagoState = async () => {
  const config = await getConfig('configuracion_tienda');
  if (config.ok) {
    setPopagoState(config.body.data.texto);
    return planesEquipo;
  }
  return null;
};

export const setPlanEquipo = tipo => () => {
  if (tipo !== planesEquipo.tipo.value) {
    planesEquipo.tipo.set(tipo);
    planesEquipo.changeTipo.set(t => t + 1);
  }
}

export function pricingPospago(planDef, plazoDef, itemPricing, pricing, planes) {
  if (planDef && (!planes || planes[planDef]) && itemPricing[pricing]?.[planDef]) {
    const plan = itemPricing[pricing][planDef];
    plan.plan = planDef;
    return plan;
  }
  return itemPricing[pricing]?.[
    Object.keys(itemPricing[pricing])
      .filter((pl) => {
        if (planes) {
          if (planes[pl]) {
            itemPricing[pricing][pl].plan = pl;
            return true;
          }
          return false;
        }
        itemPricing[pricing][pl].plan = pl;
        return true;
      })
      .sort((p1, p2) => {
        let pl1 = plazoDef;
        if (!pl1 || !itemPricing[pricing][pl1]) {
          pl1 = Object.keys(itemPricing[pricing][p1]).sort((a, b) => b - a)[0];
        }
        let pl2 = plazoDef;
        if (!pl2 || !itemPricing[pricing][pl2]) {
          pl2 = Object.keys(itemPricing[pricing][p2]).sort((a, b) => b - a)[0];
        }
        return itemPricing[pricing][p1][pl1].offer_price - itemPricing[pricing][p2][pl2].offer_price;
      })[0]
  ];
}

export const usePagoUnico = () => useEspotData('pago-unico');

export const getPagoUnico = () => getEspotData('pago-unico');

export const pagoUnicoState = hookstate({
  isPagoUnico: false,
  pricing: 'pospago',
});

export const pospagoCartState = hookstate({
  isPagoUnico: false,
  pricing: 'pospago',
  plan: null,
  plazo: null,
  autoGenerate: false,
  isIFI: false,
  sameAddressIFI: false,
});

/**
 * separa el kit en sus partes
 * @param {string} kit
 * @returns {{ plan: string, plazo: string, tipo_oferta?: string, pricing: string, isPagoUnico: boolean, isIFI: boolean} | {}}
 */
export const cartPospago = (kit) => {
  if (!kit) {
    return {};
  }
  const sp = kit.split('--');
  const plan = sp[1];
  const plazo = sp[2];
  const tipo_oferta = sp[3];
  let pricing = 'pospago';
  let isPagoUnico = false;
  let isIFI = false;

  if (tipo_oferta === 'T') {
    pricing = 'tarjeta';
    isPagoUnico = true;
  } else if (tipo_oferta === 'I') {
    pricing = 'ifi';
    isIFI = true;
  }

  return {
    plan,
    plazo,
    tipo_oferta,
    pricing,
    isPagoUnico,
    isIFI,
  };
};
